import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import Video from "../../main/Video";
import BackButton from '../../main/BackButton';
import axios from '../../../axios-backend'

const Measure = (props) => {
    const location = useLocation();
    const { type, gender } = location.state || {};
    const [videos, setVideos] = React.useState('')

    const getData = useCallback(() => {
        axios.get('/get-pro-related-video', {
            params: {
                id: type, gender: `${gender}${gender}`
            }
        }).then((data) => {
            if (data.data.video) {
                setVideos(data.data.video)
            }
        })
    }, [type, gender])

    React.useEffect(() => {
        getData()
    }, [getData])


    return (
        <>
            <BackButton />
            <Video url={`${videos}`} maxHeight="80%" />

        </>
    );
}


export default Measure;

